<template>
  <div>
      <v-layout wrap>
    <v-flex xs12 >
      <v-card outlined elevation="0" class="pa-4" data-aos="fade-up"
   data-aos-duration="1200">
   <v-flex xs12>Voters per religion</v-flex>
   <v-flex xs12 v-if="flag">
        <div>
          <center>
            <apexchart
              type="pie"
              width="480"
              :options="chartOptions2"
              :series="series2"
            >
            </apexchart>
          </center>
        </div>
      </v-flex>
      </v-card>
    </v-flex>
  </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
data() {
  return {
    appLoading: false,
    ServerError: false,
    showsnackbar: false,
    timeout: 2000,
    msg: null,
    series2: [],
    piedata2: {},
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
// GRAPH
chartOptions2: {
        colors: ["#c9540b", "#0b7475", "#62049f", "#004d1a","#721d1d","#324e65"],
        fill: {
          colors: ["#c9540b", "#0b7475", "#62049f", "#004d1a","#721d1d","#324e65"],
        },

        chart: {
          width: 480,
          type: "pie",
          toolbar: { show:true },
tools: {
            download: true,
            selection: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
          },


        },
        labels: [
        "Christian", "Hindu", "Muslim","Atheist","Other","NA",
        ],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
//
CountList:[],
adddialog:false,
adddialog2:false,
newName:"",
flag:false,
  };
},
computed: {
  userData() {
    return this.$store.state.userData;
  },
},

  mounted() {
    this.getCount();
  },
  methods: {
    getCount() {
      this.flag = false;
      this.series2 = [];
    this.appLoading = true;
    axios({
      url: "/candidate/dashboard/count",
      method: "POST",
      headers: {
        "x-auth-token": localStorage.getItem("token"),
      },
      // params: {
      //   page: this.page,
      //   limit: 50,

      // },
    })
      .then((response) => {
        if (response.data.status == true) {
          this.series2 = [];
            this.piedata2 = response.data.data.religionData;
            // for (let i = 0; i < this.barlist.length; i++) {
            //   this.piedata2[i].count 
            // }
            this.series2 = [
              this.piedata2.christiancount,
              this.piedata2.hinducount,
              this.piedata2.muslimcount,
              this.piedata2.atheistcount,
              this.piedata2.othercount,
              this.piedata2.nacount,
            ];
            this.flag = true;
        } else {
            this.showsnackbar = true;
            this.msg = response.data.msg;
          }
      })
      .catch((err) => {
        //   this.ServerError = true;
        console.log(err);
      });
  },
  },
};
</script>
<style scoped>
.bluegrad{
background: rgb(24,36,68);
background: linear-gradient(36deg, rgba(24,36,68,1) 3%, rgba(0,85,135,1) 52%, rgba(0,99,161,1) 95%);
}
</style>
